import { entities, formatters } from "@fraction/shared";
import { TrashIcon } from "lucide-react";
import { useDeleteDebtMutation } from "src/apps/PostFundedDashboard/queries";
import { useConfirmBeforeRun } from "src/hooks/useConfirmBeforeRun";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";

export function DebtList({ debts, applicationId }: { debts?: entities.Debt[]; applicationId?: string }) {
  const deleteDebtMutation = useDeleteDebtMutation(applicationId);

  const confirmDeleteDebt = useConfirmBeforeRun({
    fn: deleteDebtMutation.mutateAsync,
    message: (
      <p>
        Are you sure you want to delete this debt? <br />
        <b>This action cannot be undone.</b>
      </p>
    ),
    loading: deleteDebtMutation.isPending,
  });

  return (
    <div>
      {debts?.map((debt) => (
        <div
          className="flex flex-row items-center hover:bg-gray-200 odd:bg-gray-100 p-2 odd:rounded gap-x-4"
          key={debt.id}
        >
          <div>
            <b className="text-lg">
              {debt.withWho || ""} {debt.name || debt.description}
            </b>
            {debt.accountNumberLast4Digits ? (
              <p className="text-base text-gray-600">•••• •••• {debt.accountNumberLast4Digits}</p>
            ) : null}
          </div>
          <div>
            {debt.currentlyOwing ? (
              <Badge variant="gray" className="text-xs rounded-full font-medium">
                {formatters.number.getCurrencyFromNumber(debt.currentlyOwing)}
              </Badge>
            ) : null}
          </div>
          <Button
            className="ml-auto"
            variant="destructive"
            size="sm"
            pendingWithIcon={deleteDebtMutation.deleting === debt.id}
            onClick={() => debt.id && confirmDeleteDebt(debt.id)}
            disabled={deleteDebtMutation.deleting === debt.id}
          >
            Delete debt
            <TrashIcon className="ml-2 w-3 h-3" />
          </Button>
        </div>
      ))}
    </div>
  );
}
